module.exports = __webpack_public_path__ + "img/rocket.b2d541b9.svg";